/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["episode-page{display:block;width:100%}episode-page title-secondary-details-panel{margin-bottom:35px;padding-bottom:35px;border-bottom:1px solid var(--be-divider-lighter)}episode-page title-videos{margin-bottom:80px}episode-page .shared-ad-host{margin-top:50px;margin-bottom:40px}"];
export { styles as styles };
